<template>
  <input v-if="type === 'checkbox'" type="checkbox" class="form-check-input" :required="required" v-model="value" :disabled="disabledInternal" :id="id">
  <label :for="id" v-if="label && type === 'checkbox'" class="form-check-label control-label">{{ label }}</label>

  <label v-if="label && type !== 'checkbox'" class="control-label">{{ label }}</label>
  <Select2 v-if="type === 'select2'" :options="select2OptionsInternal" :settings="select2Settings" v-model="value" 
    v-on:select="select2OnSelect" :placeholder="placeholderInternal ?? 'Не указано'"  :disabled="disabledInternal" :id="id"/>
  <textarea
    v-else-if="type === 'textarea'" class="form-control"
    :id="id"
    :class="[modClass, { error: v$.value.$error }]"
    :disabled="disabledInternal"
    :required="requiredInternal"
    v-model="value"        
    :placeholder="placeholderInternal"
    ref="inputRef"
  />
 
  <input v-else-if="type !== 'checkbox'" class="form-control"
         :id="id"
         :class="modClass"
         :disabled="disabledInternal"
         v-model="value"
         @paste="onPaste"
         :placeholder="placeholderInternal"
         ref="inputRef"
          @keyup.enter="this.$emit('keyupEnter', $event.target.value)"
         @keydown="checkKeydown"
         />
  <div class="invalid-msg" v-if="v$.value.$error">
      <template v-if="v$.value.maxLengthValidator.$invalid">Максимальная длина поля
          {{ v$.value.maxLengthValidator.$params.value }} символов.
      </template>
      <template v-else-if="v$.value.numberFixLengthValidator.$invalid">Длина поля
          {{ v$.value.numberFixLengthValidator.$params.value }} символов, только
          цифры
      </template>
      <template v-else-if="v$.value.maxNumberLengthValidator.$invalid">Максимальная длина поля
          {{ v$.value.maxNumberLengthValidator.$params.value }} символов, только
          цифры
      </template>
      <template v-else-if="v$.value.passportDepValidator.$invalid">Введите данные в
          формате XXX-XXX, где
          X-цифры
      </template>
      <template v-else-if="v$.value.passportSerieValidator.$invalid">Длина поля 4 символа, только
          цифры
      </template>
      <template v-else-if="v$.value.birthCertNumValidator.$invalid">Длина поля 6 символов, только
          цифры
      </template>
      <template v-else-if="v$.value.passportNumValidator.$invalid">
        Длина поля 6 символов, только  цифры
      </template>
      <template v-else-if="v$.value.passportSerieForeignValidator.$invalid">Только
          цифры и буквы латинского алфавита
      </template>
      <template v-else-if="v$.value.birthCertNumForeignValidator.$invalid">Только
          цифры и буквы латинского алфавита
      </template>
      <template v-else-if="v$.value.passportNumForeignValidator.$invalid">
        Только  цифры и буквы латинского алфавита
      </template>
      <template v-else-if="v$.value.snilsValidator.$invalid">Введите данные в формате XXX-XXX-XXX XX, где X-цифры
      </template>  
      <template v-else-if="v$.value.snilsKeyValidator.$invalid">Неверный СНИЛС</template>       
<!--      <template v-if="v$.value.snilsExistValidator.$invalid">Человек с указанным СНИЛС уже зарегистрирован в системе, воспользуйтесь кнопкой Заполнить по СНИЛС
      </template>           -->
      <template v-else>Поле обязательно для заполнения</template>
  </div>  
</template>

<script>
import Inputmask from 'inputmask';
import {helpers} from "@vuelidate/validators";
import {useVuelidate} from '@vuelidate/core';
//import API from '@/modules/ras/api/ras'

const validateSnils = (snilsOrig) => {
  if (!snilsOrig) {
    return true;
  }
  var snils = snilsOrig.replaceAll('-', '').replaceAll(' ', '');
  var snilsLen = 11, snilsMagic1 = 100, snilsMagic2 = 101;
  var snilsMainLen = 9;
  if (snils.length === snilsLen) {
    var checksum = 0;
    for (var i = 0; i < snilsMainLen; i++) {
      checksum += parseInt(snils.charAt(i)) * (snilsMainLen - i);
    }
    if (checksum > snilsMagic2) {
      checksum = checksum % snilsMagic2;
    }
    if (checksum === snilsMagic1 || checksum === snilsMagic2) {
      checksum = 0;
    }
    return checksum === parseInt(snils.substr(snilsMainLen));   
  }
  return false;
}
const numberFixLengthValidator = (param, scope) =>
    helpers.withParams(
        {type: 'numberFixLengthValidator', value: param},
        (value) => {
            if (param === 0 || !value || (''+value).length === 0) return true;
            var re = new RegExp("^[0-9]{" + param + "}$");
            return {
              $valid: re.test(value),
              extraParams: {scope: scope}
            }  
        }
    );

const maxNumberLengthValidator = (param, scope) =>
    helpers.withParams(
        {type: 'maxNumberLengthValidator', value: param},
        (value) => {
            if (param === 0 || !value || (''+value).length === 0) return true;
            var re = new RegExp("^[0-9]{0," + param + "}$");
            return {
              $valid: re.test(value),
              extraParams: {scope: scope}
            }  
        }
    );

const maxLengthValidator = (param, scope) =>
    helpers.withParams(
        {type: 'maxLengthValidator', value: param},
        (value) => {
            if (param === 0 || !value) return true;
          return {
            $valid: (''+value).length <= param,
            extraParams: {scope: scope}
          }               
        }
    );

const passportSerieValidator = (useValidation, fieldType, scope) =>
    helpers.withParams(
        {type: 'passportSerieValidator'},
        (value) => {
          if (fieldType !=='passportSerie')
            return true;
          if (!useValidation)
            return true;
          if (!value || value.length === 0) return true;
          const re = new RegExp("^[0-9]{4}$");
          return {
            $valid: re.test(value),
            extraParams: {scope: scope}
          }   
        }
    );

const passportSerieForeignValidator = (useValidation, fieldType, scope) =>
    helpers.withParams(
        {type: 'passportSerieForeignValidator'},
        (value) => {
          if (fieldType !=='passportSerieForeign')
            return true;
          if (!useValidation)
            return true;
          if (!value || value.length === 0) return true;
          const re = new RegExp("^[0-9a-zA-Z]+$");
          return {
            $valid: re.test(value),
            extraParams: {scope: scope}
          }   
        }
    );

const passportNumValidator = (useValidation, fieldType, scope) =>
    helpers.withParams(
        {type: 'passportNumValidator'},
        (value) => {
          if (fieldType !=='passportNum')
            return true;
          if (!useValidation)
            return true;
          if (!value || value.length === 0) return true;
          const re = new RegExp("^[0-9]{6}$");
          return {
            $valid: re.test(value),
            extraParams: {scope: scope}
          }          
        }
    );

const passportNumForeignValidator = (useValidation, fieldType, scope) =>
    helpers.withParams(
        {type: 'passportNumForeignValidator'},
        (value) => {
          if (fieldType !=='passportNumForeign')
            return true;
          if (!useValidation)
            return true;
          if (!value || value.length === 0) return true;
          const re = new RegExp("^[0-9a-zA-Z]+$");
          return {
            $valid: re.test(value),
            extraParams: {scope: scope}
          }          
        }
    );

const requiredValidator = (required, scope, type) =>
    helpers.withParams(
        {type: 'requiredValidator'},
        (value) => { 
          if (!required)
            return true;
          var res = true;
          if (type === 'snils' || type === 'phone' || type === 'passportDep')
            res = (value ? value.replaceAll('-', '').replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '') : '') !== '';
          else if (type === 'checkbox') 
            res = !!value;
          else if (type === 'select2')
            res = (value && (value > 0 || value == 'false' || value == 'true' || value == -1))
          else{
            //console.log('----' + value.trim().length + '------' )
            res = value && value.toString().trim().length > 0
            console.log(res)
          }

          res = !!res;

          return {
            $valid: res,
            extraParams: {scope: scope}
          }
        }
    );

const birthCertNumValidator = (useValidation, fieldType, scope) =>
    helpers.withParams(
        {type: 'birthCertNumValidator'},
        (value) => {
          if (fieldType !=='birthCertNum')
            return true;
          if (!useValidation)
            return true;
          if (!value || value.length === 0) return true;
          const re = new RegExp("^[0-9]{6}$");
          return {
            $valid: re.test(value),
            extraParams: {scope: scope}
          }
        }
    );

const birthCertNumForeignValidator = (useValidation, fieldType, scope) =>
    helpers.withParams(
        {type: 'birthCertNumValidatorForeign'},
        (value) => {
          if (fieldType !=='birthCertNumForeign')
            return true;
          if (!useValidation)
            return true;
          if (!value || value.length === 0) return true;
          const re = new RegExp("^[0-9a-zA-Z]+$");
          return {
            $valid: re.test(value),
            extraParams: {scope: scope}
          }
        }
    );

const indexValidator = (useValidation, fieldType, scope) =>
    helpers.withParams(
        {type: 'indexValidator'},
        (value) => {
          if (fieldType !=='index')
            return true;
          if (!useValidation)
            return true;
          if (!value || value.length === 0) return true;
          var re = new RegExp("^[0-9]{6}$");
          return {
            $valid: re.test(value),
            extraParams: {scope: scope}
          }     
        }
    );

const passportDepValidator = (useValidation, fieldType, scope) =>
    helpers.withParams(
        {type: 'passportDepValidator'},
        (value) => {
        if (fieldType !=='passportDep')
          return true;
        if (!useValidation)
          return true;
        if (!value || value.length === 0) return true;
        var re = new RegExp("^[0-9]{3}-[0-9]{3}$");
          return {
            $valid: re.test(value),
            extraParams: {scope: scope}
          }     
        }
    );

const snilsValidator = (useValidation, fieldType, scope) =>
    helpers.withParams(
        {type: 'snilsValidator'},
    (value) => {
      if (fieldType !=='snils')
        return true;
      if (!useValidation)
        return true;
      if (!value || value.length === 0) 
        return true;
      var re = new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{3} [0-9]{2}$");
      return {
            $valid: re.test(value),
            extraParams: {scope: scope}
          }     
    }
);

const snilsKeyValidator = (useValidation, fieldType, scope) =>
    helpers.withParams(
        {type: 'snilsValidator'},
    (value) => {
      if (fieldType !=='snils')
        return true;
      if (!useValidation)
        return true;
      if (!value || value.length === 0) 
        return true;
      return {
            $valid: validateSnils(value),
            extraParams: {scope: scope}
          }          
    }
);

export default {
  name: 'ComponentInput',
  props: {
    disabled: {
      type: Boolean
    },
      id: String,
    modelValue: [String, Number, Object, Boolean],
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: [String, Number],
      default: ''
    },
    modClass: {
      type: String,
      default: ''
    },
    inputMask: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      validator: function (value) {
        return ['phone', 'phoneCity', 'passportSerie', 'passportNum', 'birthCertNum', 'snils', 
        'passportSerieForeign', 'passportNumForeign', 'birthCertNumForeign',
        'passportDep', 'time', 'timeLong', 'number', 'select2', 'checkbox', 'index', 'int'].indexOf(value) !== -1
      }
    },
    useDefaultValidation: {
      type: Boolean,
      default: true
    },
    maxLength: {
      type: Number,
      default: 0
    },
    fixLength: {
      type: Number,
      default: 0
    },
    maxNumberLength: {
      type: Number,
      default: 0
    },
    scopeName: {
      type: String,
      default: ''
    },
    reestr: {
      type: String,
      required: false,
      validator: function (value) {
        return ['repres', 'patient'].indexOf(value) !== -1
      }
    },
    select2Options: {
      type: Array,
      default: () => []
    },
    select2Settings: {
      type: Object,
      default: () => {}
    },
    additionalData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    disabled: function (newValue) {
        this.disabledInternal = newValue;
    },
    select2Options: {
      handler: function (val) {
        this.select2OptionsInternal = val;
      },
      deep: true    
    },
    placeholder: function (newValue) {
        this.placeholderInternal = newValue;
    },                 
  },
  emits: ['update:modelValue', 'select2OnSelect'],
  data() {
    return {
      placeholderInternal: this.placeholder,
      maskInternal: '',
      disabledInternal: this.disabled,
      select2OptionsInternal: this.select2Options
    }
  },
  computed: {
    value: {
      get() {
        if (this.type === 'select2' && this.modelValue && !Array.isArray(this.modelValue))
          return this.modelValue.toString();
        return this.modelValue;
      },
      set (value) {
        this.$emit('update:modelValue', value);
      }
    }, 
  },
  mounted() {
    this.fillInputParams();
    var mask = this.maskInternal || this.inputMask;
    if (mask !== '') {
     var im = new Inputmask(mask);
     //im.mask($('.form-control'));
     im.mask($(this.$refs.inputRef));
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
      return {
        value: {
                    requiredValidator: requiredValidator(this.required, this.scopeName, this.type),
                    passportDepValidator: passportDepValidator(this.useDefaultValidation, this.type, this.scopeName),
                    passportSerieValidator: passportSerieValidator(this.useDefaultValidation, this.type, this.scopeName),
                    passportNumValidator: passportNumValidator(this.useDefaultValidation, this.type, this.scopeName),
                    birthCertNumValidator: birthCertNumValidator(this.useDefaultValidation, this.type, this.scopeName),
                    passportSerieForeignValidator: passportSerieForeignValidator(this.useDefaultValidation, this.type, this.scopeName),
                    passportNumForeignValidator: passportNumForeignValidator(this.useDefaultValidation, this.type, this.scopeName),
                    birthCertNumForeignValidator: birthCertNumForeignValidator(this.useDefaultValidation, this.type, this.scopeName),
                    indexValidator: indexValidator(this.useDefaultValidation, this.type, this.scopeName),
                    numberFixLengthValidator: numberFixLengthValidator(this.fixLength, this.scopeName),
                    maxNumberLengthValidator: maxNumberLengthValidator(this.maxNumberLength, this.scopeName),
                    snilsValidator: snilsValidator(this.useDefaultValidation, this.type, this.scopeName),
                    snilsKeyValidator: snilsKeyValidator(this.useDefaultValidation, this.type, this.scopeName),
                    maxLengthValidator: maxLengthValidator(this.maxLength, this.scopeName)
                }
    }
  },
  methods: {
    select2OnSelect(o) {
      this.$emit('select2OnSelect', {value: o, additional: this.additionalData});
    },
    fillInputParams(){
      if (this.type === 'phone') {
        this.placeholderInternal = '+7(___)___-__-__';
        this.maskInternal = '+7(999)999-99-99';
      }
      else if (this.type === 'phoneCity') {
        this.placeholderInternal = '+7(_____)___-__';
        this.maskInternal = '+7(99999)999-99';
      }
      else if (this.type==='snils') {
        this.placeholderInternal = 'XXX-XXX-XXX XX';
        this.maskInternal = '999-999-999 99';
      }
      else if (this.type==='passportSerie') {
        this.placeholderInternal = 'XXXX';
        this.maskInternal = '9999';
      }
      else if (this.type==='passportNum') {
        this.placeholderInternal = 'XXXXXX';
        this.maskInternal = '999999';
      }
      else if (this.type==='birthCertNum') {
        this.placeholderInternal = 'XXXXXX';
        this.maskInternal = '999999';
      }
      else if (this.type==='index') {
        this.placeholderInternal = 'XXXXXX';
        this.maskInternal = '999999';
      }      
      else if (this.type==='passportDep') {
        this.placeholderInternal = 'XXX-XXX';
        this.maskInternal = '999-999';
      }
      else if (this.type ==='time')
        this.maskInternal = '99:99';
      else if (this.type==='timeLong') {
        this.placeholderInternal = 'ммм:сс';
        this.maskInternal = '999:99';
      }

    },
    onPaste(evt) {
      if (this.type === "int") {
        const reg = new RegExp("^[0-9]+$", "g");
        if (!reg.test(evt.clipboardData.getData('text'))) {
          evt.preventDefault();
          return false;
        }
      }

      return true;
    },
    checkKeydown(event) {
      if(this.type == "int") {
        var res = true;
        if (event.keyCode != 17 && event.keyCode != 37 && event.keyCode != 39 && event.keyCode != 8 && event.keyCode != 46 && event.keyCode != 9 && event.keyCode != 13) {
            if (event.keyCode < 48 || (event.keyCode > 57 && event.keyCode < 96) || event.keyCode > 105) {
                if (event.ctrlKey === true && (event.keyCode == 67 || event.keyCode == 86)) {
                    res = true;
                }
                else {
                  event.preventDefault();
                  res = false;
                  
                }
                return res;
            }

            if ((event.keyCode >= 48 && event.keyCode <= 57) && event.shiftKey === true) {
              event.preventDefault();
              res = false;
            }
        }
        return res;
      }
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '/src/modules/ras/views/index';
@import "../../assets/theme/default/colors";
.form-control {
  max-width: 100%;
  background: $white;
  border: 1px solid $gray-light1;
  box-sizing: border-box;
  border-radius: 6px;
}
.control-label{
  font-weight: 400 !important;
  color: $gray-dark;
  font-size: 16px;
}
.form-check.required .control-label:after {
  content: "*";
  color: red;
}
.form-group.required .control-label:after {
  content: "*";
  color: red;
}
textarea {
  display: block;
  width: 100%;
  height: 103px !important;
  resize: none
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  opacity: 1;
  color: $gray-dark;
}
</style>
